
import { Component, Vue, Prop } from 'vue-property-decorator';
import { ModalFooter } from '@/modules/common/components/__deprecated__/Modal';
import { Steps } from '../PortfolioSuggestedModal/PortfolioSuggestedModal.vue';
import { SuggestionType } from '@/modules/investments/types/suggestion';
import { NotificationTypes } from '@/modules/common/services/http/notification';
import {
  PorfolioSuggestedUpdateStatusDocument,
  EGlobalSummaryPortfolioStatus
} from '@/modules/common/services/graphql/server/server.sdk';
import {
  investmentAgreement,
  EInvestmentAgreementStatus,
  IInvestmentAgreementPayload,
  IInvestmentSuggestion
} from '@/modules/wealth/services/investment';
import { SuggestionModule } from '@/modules/home/store/suggestions';
import { namespace } from 'vuex-class';
import * as trackingInvestmentRefuse from './track-investment-events';
import * as trackRedeemRefuse from './track-redeem-events';

const customerModule = namespace('CustomerModule');

@Component({
  components: { ModalFooter }
})
export default class PortfolioSuggestedRefuse extends Vue {
  @Prop({ type: String, required: true })
  public portfolioId!: string;

  @Prop({ type: String, required: true })
  public portfolioName!: string;

  @Prop({ type: String, required: false, default: SuggestionType.Wallet })
  public suggestionType!: SuggestionType;

  @customerModule.Getter('getCustomerId')
  private customerId!: string;

  created() {
    if (this.suggestionType === SuggestionType.Investment) {
      trackingInvestmentRefuse.viewConfirmRefuseInvestmentAmplitude();
    } else if (this.suggestionType === SuggestionType.Redeem) {
      trackRedeemRefuse.trackViewRefuseSuggestion();
    }
  }

  private notifyUser() {
    const textNotify = this.isSuggestionTypeWallet
      ? `Carteira ${this.portfolioName} recusada!`
      : 'Sugestão recusada';

    this.$emit('notify-user', {
      group: 'wrn-notification-portfolio-suggestion',
      text: textNotify,
      type: NotificationTypes.error
    });
  }

  private modalNavigate(step: Steps) {
    this.$emit('modal-navigate', step);
  }

  public handlerBack() {
    if (this.suggestionType === SuggestionType.Investment) {
      trackingInvestmentRefuse.cancelConfirmRefuseInvestmentAmplitude();
    } else if (this.suggestionType === SuggestionType.Redeem) {
      trackRedeemRefuse.trackClickCancelRefuse();
    }
    this.modalNavigate(Steps.Detail);
  }

  public async handlerRefuse() {
    await this.refuseSuggestion();

    this.notifyUser();
    this.modalNavigate(Steps.List);
  }

  private async refuseSuggestion() {
    if (this.suggestionType === SuggestionType.Wallet) {
      await this.refusePortfolio();
    } else {
      this.trackClickConfirmRefuse();
      await this.confirmRefuseSuggestion();
    }
  }

  private trackClickConfirmRefuse() {
    if (this.suggestionType === SuggestionType.Investment) {
      trackingInvestmentRefuse.acceptConfirmRefuseInvestmentAmplitude();
    } else {
      trackRedeemRefuse.trackClickConfirmRefuse();
    }
  }

  private async refusePortfolio() {
    await this.$apollo
      .mutate({
        mutation: PorfolioSuggestedUpdateStatusDocument,
        variables: {
          customerId: this.customerId,
          portfolioId: this.portfolioId,
          status: EGlobalSummaryPortfolioStatus.Rejected
        }
      })
      .then(() => {
        SuggestionModule.removeSuggestion(this.portfolioId);
        this.notifyUser();
        this.modalNavigate(Steps.List);
      })
      .catch(() => {
        this.$emit('notify-user', {
          group: 'wrn-notification-portfolio-suggestion',
          text: `Não foi possível recusar a ${this.portfolioName}! Tente novamente`,
          type: NotificationTypes.error
        });
      });
  }

  private async confirmRefuseSuggestion() {
    const payloadInvestmentAgrrement: IInvestmentAgreementPayload = {
      transactionId: this.portfolioSuggestion.transactionId,
      customerId: this.customerId,
      status: EInvestmentAgreementStatus.Rejected,
      updatedBy: this.customerId
    };

    try {
      await investmentAgreement(payloadInvestmentAgrrement);
      SuggestionModule.removeSuggestion(
        payloadInvestmentAgrrement.transactionId
      );
      this.confirmRefuseSuccessful();
      this.notifyUser();
      this.modalNavigate(Steps.List);
    } catch {
      this.$emit('notify-user', {
        group: 'wrn-notification-portfolio-suggestion',
        text: `Não foi possível recusar a sugestão de investimento! Tente novamente`,
        type: NotificationTypes.error
      });
    }
  }

  private confirmRefuseSuccessful() {
    if (this.suggestionType === SuggestionType.Redeem) {
      trackRedeemRefuse.trackConfirmRefuseSuccessful();
    }
  }

  public get isSuggestionTypeWallet() {
    return this.suggestionType === SuggestionType.Wallet;
  }

  public get portfolioSuggestion() {
    return SuggestionModule.suggestionDetails.detail as IInvestmentSuggestion;
  }
}
